/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, type Store } from '@atlassian/react-sweet-state';
import * as actions from './actions/index.tsx';
import type { State, Actions } from './types.tsx';

// @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'TenantContext'.
const initialState: State = { tenantContext: null };

const tenantContextStore: Store<State, Actions> = createStore<State, Actions>({
	name: 'tenantContext',
	initialState,
	actions,
});
export default tenantContextStore;
